import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaDownload, FaTimes } from 'react-icons/fa';
import usePWA from '../../hooks/usePWA';

const DISMISS_KEY = 'qfl_install_dismissed_until';
const DISMISS_DAYS = 3;

function isDismissed() {
  try {
    const until = localStorage.getItem(DISMISS_KEY);
    if (!until) return false;
    return Date.now() < Number(until);
  } catch {
    return false;
  }
}

function saveDismiss() {
  try {
    const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(DISMISS_KEY, String(until));
  } catch {}
}

function InstallBanner() {
  const { isInstallable, isInstalled, promptInstall } = usePWA();
  const [visible, setVisible] = React.useState(false);

  // Apparaît après 4s, se ferme automatiquement après 8s supplémentaires
  React.useEffect(() => {
    if (isInstalled || !isInstallable || isDismissed()) return;

    const showTimer = setTimeout(() => setVisible(true), 4000);
    const hideTimer = setTimeout(() => setVisible(false), 12000); // 4s + 8s

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [isInstallable, isInstalled]);

  const dismiss = () => {
    setVisible(false);
    saveDismiss();
  };

  const handleInstall = async () => {
    const accepted = await promptInstall();
    if (accepted) setVisible(false);
  };

  if (isInstalled || !isInstallable) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          style={{
            position: 'fixed',
            bottom: 16,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 32px)',
            maxWidth: 448,
            zIndex: 9000,
            background: 'linear-gradient(135deg, #1a4a2e, #0d2b1a)',
            border: '1px solid rgba(240,180,41,0.4)',
            borderRadius: 16,
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            boxShadow: '0 8px 30px rgba(0,0,0,0.5), 0 0 20px rgba(240,180,41,0.1)',
          }}
        >
          <img
            src="/logo-qfl-clear.png"
            alt="QFL"
            style={{ width: 40, height: 40, objectFit: 'contain', mixBlendMode: 'screen', flexShrink: 0 }}
          />

          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontFamily: "'Rajdhani', sans-serif", fontWeight: 700, color: '#fff', fontSize: '0.9rem', margin: 0 }}>
              Installer OM QUIZ
            </p>
            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem', margin: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              Joue sans navigateur, comme une vraie app !
            </p>
          </div>

          <button
            onClick={handleInstall}
            style={{
              background: 'linear-gradient(135deg, #f0b429, #d4920a)',
              border: 'none',
              borderRadius: 10,
              padding: '8px 14px',
              color: '#0d2b1a',
              fontFamily: "'Rajdhani', sans-serif",
              fontWeight: 700,
              fontSize: '0.8rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            <FaDownload size={12} />
            INSTALLER
          </button>

          <button
            onClick={dismiss}
            style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.4)', cursor: 'pointer', padding: 4, flexShrink: 0 }}
            aria-label="Fermer"
          >
            <FaTimes size={14} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default InstallBanner;
